import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import { toISO3 } from "@src/cloud-connect/user-manager/utils/to-iso3";
import store from "@src/reducers/store";
import { Language } from "@src/reducers/your-reducer";
import { SupportAgentTicket } from "@src/types/support";

export interface GetSupportTicketResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const getSupportTicketByIdWithLanguageUseCase = async (
  ticketId: string,
  language: Language,
): Promise<GetSupportTicketResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const ISO6393Language = toISO3(language);

    const response = await apiUseCases.getSupportTicketByIdWithLanguage(
      namespace,
      ticketId,
      ISO6393Language,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch tickets").message,
    };
  }
};
